/* eslint-disable */

window.UVMapShader = {

    uniforms: {
    },

    vertexShader: Utils.loadTextFileInject(
        "/assets/js/shaders/UVMapShader.vs.glsl"
    ),

    fragmentShader: Utils.loadTextFileInject(
        "/assets/js/shaders/UVMapShader.fs.glsl"
    )

};
